import { render, staticRenderFns } from "./MMultiSelectChoices.vue?vue&type=template&id=21fca2eb"
import script from "./MMultiSelectChoices.vue?vue&type=script&lang=js"
export * from "./MMultiSelectChoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports